import { AccessTimeFilled, CheckBox, CheckBoxOutlineBlank, Delete, Edit, KeyboardDoubleArrowDown } from "@mui/icons-material";
import { format, isValid } from 'date-fns';
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { LocationDto, ReminderDto, TicketDto, TicketFilterDto } from "../../../api-client";
import {
  useDeleteReminder,
  useCreateTicket,
  useUpdateTicket,
  useTicketFilter,
} from "../../../stores/Ticketing";
import { useAllUsersBasic } from "../../../stores/User";
import useStore from "../../../helpers/useStore";
import { TicketsStoreContext } from "../../../stores/Ticketing/tickets.provider";
import { UserContext } from "../../../stores/User/User.provider";
import { attentionColors, mobiliTheme } from "../../../themes/mobiliTheme";

import { commonTabStyle } from "../../PatientOverview/tabStyles";

import { observer } from "mobx-react";
import FlatCard from "../../../atoms/FlatCard";
import { MobiliAvatar } from "../../../atoms/MobiliAvatar";
import WarningDialog from "../../../atoms/WarningDialog";
import { useMasterTables } from "../../../stores/MasterTables";
import notificationStore from "../../../stores/Notification/notificationStore";
import AllActivityTicket from "./AllActivityTicket";
import Involvements from "./Involvements";
import TicketComments from "./TicketComments";
import TicketHistoryTimeline from "./TicketHistoryTimeline";
import { DatePicker } from "@mui/x-date-pickers";
import EditReminderDialog from './EditReminderDialog';
import TicketIcon from './TicketIcon';
import { TICKET_STATUS, TICKET_PRIORITY, TICKET_UI_DEFAULTS } from '../constants/ticketConstants';

interface TicketFormProps {
  openTicket: boolean;
  onCloseTicketForm?: () => void;
  data?: any;
  type?: { ticketType: string; title: string; id: string; idType: string };
  // editable?: boolean;
  // setEditable?:any;
  refresh?: boolean;
  setRefresh?: (value: boolean) => void;
  isTicketLoading?: boolean;
  onTicketUpdate?: (ticket: TicketDto) => void;
}



const CreateTicketForm: React.FC<TicketFormProps> = observer(
  ({
    openTicket,
    onCloseTicketForm,
    data,
    refresh,
    setRefresh,
    // editable,
    // setEditable,
    isTicketLoading,
    onTicketUpdate,
  }) => {
    const UserStore = useStore(UserContext);
    const TicketsStore = useStore(TicketsStoreContext);
    const { user } = UserStore;
    const { data: allUsersBasicData } = useAllUsersBasic(false);
    const allUsersBasic = useMemo(() => allUsersBasicData ?? [], [allUsersBasicData]);

    const [userOptions, setUserOptions] = useState<any>(allUsersBasic);
    const [initialRender, setInitialRender] = useState(true);
    const [selectedCreaterOption, setCreaterSelectedOption] = useState<any>(null); // New state to hold the selected option

    const [anchorEl, setAnchorEl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const [reminders, setReminders] = useState<Array<{
      id?: number;
      date: Date | null;
      alternativeMessage?: string;
      isResolved: boolean;
      createdByUser?: {
        id: string;
        nickName?: string;
        firstName?: string;
        lastName?: string;
      };
    }>>([]);
    
    const [newReminder, setNewReminder] = useState<{
      date: Date | null;
      alternativeMessage: string;
      isResolved: boolean;
    }>({
      date: null,
      alternativeMessage: '',
      isResolved: false
    });
    const { data: masterTablesData } = useMasterTables();
    const addTicket = useCreateTicket();
    const updateTicket = useUpdateTicket();
    const { data: rawTicketFilters, isLoading: ticketFiltersLoading } = useTicketFilter();
    const ticketFilters: TicketFilterDto[] = rawTicketFilters ?? [];

    const locationsOptions = masterTablesData
      ? masterTablesData.filter((obj: any) => "location" in obj).map((obj: any) => obj.location)[0]
      : null;

    const handleTabChange = (event: any, newValue: any) => {
      setTabValue(newValue);
    };

    const handleOpenPopover = (event: any) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClosePopover = () => {
      setAnchorEl(null);
    };
    useEffect(() => {
      //get ticket filters
    }, []);

    useEffect(() => {
      // console.log("datadkkdkdskkd", data, user);
      try {
        if (data) {
          const mergedData = {
            ...initialValues,
            ...data,
          };
          // setTicketData(data);
          // Set reminders data if it exists
          if (mergedData.reminders && Array.isArray(mergedData.reminders)) {
            // console.log("mergedData.reminders -----------> ", mergedData.reminders);
            setReminders(
              mergedData.reminders.map((reminder: any) => ({
                id: reminder.id,
                date: reminder.date ? new Date(reminder.date) : null,
                alternativeMessage: reminder.alternativeMessage,
              }))
            );
          }

          // Check if assignedToUser exists in data
          if (mergedData.assignedToUser?.id) {
            // Create a new object with id and label properties
            const assignedToOption = {
              id: mergedData.assignedToUser.id,
              label: `${mergedData.assignedToUser.firstName} ${mergedData.assignedToUser.lastName}`,
            };
            setSelectedAssigneeOption(mergedData.assignedToUser); // Update selectedOption with assignedToUser
          }
          if (mergedData.createdByUser?.id) {
            // Create a new object with id and label properties
            const createOption = {
              id: mergedData.createdByUser.id,
              label: `${mergedData.createdByUser.firstName} ${mergedData.createdByUser.lastName}`,
            };
            setTicketData({
              ...mergedData,
              createdByUser: {
                id: mergedData?.createdByUser.id as any,
                nickName: mergedData?.createdByUser.nickName,
                firstName: mergedData?.createdByUser.firstName,
                lastName: mergedData?.createdByUser.lastName,
              },
              locationId: mergedData?.location?.id || user?.locationId,
            });
          } else if (!mergedData.createdByUser?.id) {
            setTicketData({
              ...mergedData,
              createdByUser: {
                id: user?.id as any,
                nickName: user?.nickName,
                firstName: user?.firstName,
                lastName: user?.lastName,
              },
              locationId: mergedData?.location?.id || user?.locationId,
            });
          }
        } else {
          setTicketData((prevTicketData) => ({
            ...prevTicketData,
            createdByUser: {
              id: user?.id as any,
              nickName: user?.nickName,
              firstName: user?.firstName,
              lastName: user?.lastName,
            },
            locationId: data?.location?.id || (user?.locationId as string),
          }));
        }
      } catch (error) {
        console.error("Error while fetching data:", error);
      }
    }, [data, user]);

    useEffect(() => {
      const fetchData = async () => {
        try {
          if (user) {
            // Fetch user data
            // const userResponse = await getUserBy(user.location?.id as string);
            const userResponse = allUsersBasic;
            // Find index of logged-in user in userResponse
            const userIndex = userResponse.findIndex((u: any) => u.id === user.id);

            // If logged-in user exists in userResponse, move it to the top
            if (userIndex !== -1) {
              userResponse.splice(userIndex, 1); // Remove logged-in user from its current position
              userResponse.unshift(user); // Add logged-in user at the beginning
            }
            setUserOptions(userResponse);
          } else {
            setUserOptions([]);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      // Fetch data when user changes or on initial render
      if (!initialRender || user) {
        fetchData();
      }

      // Set initialRender flag to false after initial render
      setInitialRender(false);
    }, [user, initialRender, allUsersBasic]);

    const initialValues = {
      assignedToUser: { id: "" },
      description: "",
      activities: [],
      createdByUser: user
        ? {
            id: user?.id as any,
            nickName: user?.nickName,
            firstName: user?.firstName,
            lastName: user?.lastName,
          }
        : undefined,
      updatedByUser: user
        ? {
            id: user?.id as any,
            nickName: user?.nickName,
            firstName: user?.firstName,
            lastName: user?.lastName,
          }
        : undefined,
      ticketType: "",
      ticketStatus: TICKET_UI_DEFAULTS.STATUS,
      priority: TICKET_PRIORITY.LOW,
      comments: "",
      rxId: data?.rx?.id || data?.id,
      patientId: data?.patient?.id || data?.patientId,
      transactionId: data?.transaction?.id || data?.transactionId,
      appointmentId: data?.appointment?.id || data?.appointmentId,
      locationId: user?.locationId || "",
    };
    const [ticketData, setTicketData] = useState<TicketDto>(initialValues);

    const [unsavedChangesWarning, setShowunsavedChangesWarning] = useState(false);
    const [unsavedChanges, setUnsavedChanges] = useState(false); // Flag to track unsaved changes
    const [deleteReminderDialog, setDeleteReminderDialog] = useState<{open: boolean; index: number | null}>({
      open: false,
      index: null
    });

    const [editReminderDialog, setEditReminderDialog] = useState<{
      open: boolean;
      reminder: {
        id?: number;
        date: Date | null;
        alternativeMessage?: string;
        isResolved: boolean;
      } | null;
      index: number | null;
    }>({
      open: false,
      reminder: null,
      index: null
    });

    const handleChange = (e: any) => {
      setUnsavedChanges(true);

      const { name, value } = e.target;
      const tktData = { ...ticketData, [name]: value };
      setTicketData(tktData);
    };

    // Merge linked-entity changes (patient / Rx / doctor / clinic) into the local
    // ticket draft so they are included when the ticket is created.
    const handleLinkagesChange = (changes: Partial<TicketDto>) => {
      if (!changes || Object.keys(changes).length === 0) return;
      setUnsavedChanges(true);
      setTicketData((prev) => ({ ...prev, ...changes }));
    };
    const isValidTicketStatus = (
      tktFilters: TicketFilterDto[],
      ticketType: string | undefined,
      ticketStatus: string | undefined
    ): boolean => {
      if (!ticketType) return false;

      return (
        tktFilters
          .find((filter) => String(filter.ticketType.value) === String(ticketType)) // Ensure filter is found
          ?.statuses?.some((statusObj) => String(statusObj.value) === String(ticketStatus)) || false
      );
    };

    const isValidTicketPriority = (
      tktFilters: TicketFilterDto[],
      ticketType: string | undefined,
      ticketPriority: string | undefined
    ): boolean => {
      if (!ticketType) return false;

      return (
        tktFilters
          .find((filter) => String(filter.ticketType.value) === String(ticketType)) // Ensure filter is found
          ?.priorities?.some((statusObj) => String(statusObj.value) === String(ticketPriority)) ||
        false
      );
    };

    const validateTicketData = (ticketData: TicketDto): string => {
      let errorMessage = "";

      if (!ticketData.ticketType) return (errorMessage = "Problemtyp fehlt");
      if (!ticketData.ticketStatus) return (errorMessage = "Status fehlt");

      if (!isValidTicketStatus(ticketFilters, ticketData.ticketType, ticketData.ticketStatus))
        return (errorMessage = "ungültiger Status");

      // Only validate priority if this ticket type requires priorities
      const ticketTypeFilter = ticketFilters.find(filter => filter.ticketType.value === ticketData.ticketType);
      if (ticketTypeFilter?.hasPriorities && !isValidTicketPriority(ticketFilters, ticketData.ticketType, ticketData.priority))
        return (errorMessage = "ungültige Priorität");

      return errorMessage;
    };
    const handleSubmit = async (e?: any) => {
      try {
        setLoading(true);
        if (e) {
          e.preventDefault();
        }

        // All reminders (both existing and new) are in the reminders array
        const remindersPayload: ReminderDto[] = reminders
          .filter(reminder => reminder.date !== null)
          .map(reminder => ({
            ...(reminder.id && { id: reminder.id }), // only include id for existing reminders
            date: reminder.date!.toISOString(),
            alternativeMessage: reminder.alternativeMessage || undefined,
            status: reminder.isResolved || false
          })) as ReminderDto[];

        // Create the complete ticket payload
        const ticketPayload: TicketDto = {
          ...ticketData,
          priority: ticketData.priority?.toUpperCase(), // Ensure priority is uppercase
          reminders: remindersPayload.map(reminder => ({
            ...reminder,
            ticketId: ticketData.id // Add the ticket ID for existing tickets
          }))
        };

        // console.log('Ticket payload with reminders:', ticketPayload);

        //Validate ticketData
        const errorMessage = validateTicketData(ticketPayload);
        if (errorMessage) return notificationStore.showMessage(errorMessage, "error");

        ticketData.updatedByUser = {
          id: user?.id as any,
          nickName: user?.nickName,
          firstName: user?.firstName,
          lastName: user?.lastName,
        };
        //If status is not present then select the first status

        // Set default ticketType and ticketStatus if not present

        if (!ticketData.ticketType) {
          // console.log("ajkskks", ticketFilters[0], ticketFilters);
          let firstTicketFilter = ticketFilters[0];
          ticketData.ticketType = firstTicketFilter.ticketType.value;
          ticketData.ticketStatus = firstTicketFilter.statuses[0].value;
          ticketData.priority = firstTicketFilter.priorities[0].value;
        }

        // Validate and update ticketStatus
        const validStatus = isValidTicketStatus(
          ticketFilters,
          ticketData.ticketType,
          ticketData.ticketStatus
        );

        if (!validStatus) {
          ticketData.ticketStatus = ticketFilters.find(
            (filter) => filter.ticketType.value === ticketData.ticketType
          )?.statuses[0].value;
        }

        //Validate and update ticket prority
        const validPriority = isValidTicketPriority(
          ticketFilters,
          ticketData.ticketType,
          ticketData.priority
        );

        if (!validPriority) {
          ticketData.priority = ticketFilters.find(
            (filter) => filter.ticketType.value === ticketData.ticketType
          )?.priorities[0].value;
        }

        // Validate empty ticket locationd
        if (!ticketData.locationId) {
          return notificationStore.showMessage("Fehlender Standort", "error");
        }
        let response;
        if (!ticketData.id) {
          addTicket.mutate(ticketPayload);
        } else {
          updateTicket.mutate({ ticketId: ticketData.id as number, ticketData: ticketPayload });

          // if (onTicketUpdate && ticketData.id) {
          //   onTicketUpdate(response);
          // }
        }

        setUnsavedChanges(false);
        handleClose();
        // if (setRefresh) {
        //   // setRefresh(!refresh);
        //   setRefresh(true);
        // }

        setShowunsavedChangesWarning(false);

        // if (response) {
        //   setTicketData(response);
        // }
      } catch (error) {
        console.error("Error while ticket creation:", error);
      } finally {
        // Set loading back to false when the API call is complete
        setLoading(false);
        // setTicketData(initialValues);
      }
    };

    const handleAssignToMe = (type: string) => {
      setUnsavedChanges(true);
      // Assign the logged-in user
      if (user) {
        if (type === "assignedToUser") {
          setSelectedAssigneeOption(user); // Update the selected option state with the logged-in user's data
          setTicketData({
            ...ticketData,
            assignedToUser: {
              id: user.id as any,
              nickName: user?.nickName,
              firstName: user?.firstName,
              lastName: user?.lastName,
            },
          }); // Assign the logged-in user's ID
        }
        if (type === "createdByUser") {
          setCreaterSelectedOption(user); // Update the selected option state with the logged-in user's data
          setTicketData({
            ...ticketData,
            createdByUser: {
              id: user.id as any,
              nickName: user?.nickName,
              firstName: user?.firstName,
              lastName: user?.lastName,
            },
          }); // Assign the logged-in user's ID
        }
      }
      // console.log(
        // "Assign to me clicked",
// 
        // ticketData.assignedToUser?.id,
        // user
      // );
    };
    const [fetchingMoreUsers, setFetchingMoreUsers] = useState(false);
    // const handleMoreUsersClick = async () => {
    //   setFetchingMoreUsers(true);
    //   try {
    //     const moreUsers = await getAllUsers();
    //     // Filter out duplicate users by ID
    //     const filteredUsers = moreUsers.filter(
    //       (user) => !userOptions.some((existingUser: any) => existingUser.id === user.id)
    //     );
    //     setUserOptions((prevUsers: any) => [...prevUsers, ...filteredUsers]);
    //     // setFetchingMoreUsers(false);
    //   } catch (error) {
    //     console.error("Error fetching more users:", error);
    //     setFetchingMoreUsers(false);
    //   }
    // };
    // console.log(
      // "selectedOption",
// 
      // ticketData.assignedToUser?.id,
      // data
    // );
    const [anchorEl1, setAnchorEl1] = useState(null);
    const [selectedPriority, setSelectedPriority] = useState(
      <KeyboardDoubleArrowDown sx={{ color: attentionColors.lowPriority }} />
    ); // Default selected priority symbol
    const handleClick = (event: any) => {
      setAnchorEl1(event.currentTarget);
    };

    const handleClose = () => {
      if (onCloseTicketForm) {
        setTicketData(initialValues);
        setUnsavedChanges(false); // Reset unsaved changes flag
        setSelectedAssigneeOption(null);
        // Reset reminder states
        setReminders([]);
        setNewReminder({
          date: null,
          alternativeMessage: '',
          isResolved: false
        });
        // setTicketData(getInitialTicketData());
        // setTabValue(0); // Reset tab to default (Alle) when closing
        onCloseTicketForm();
      }
    };
    const handleCloseTicketFormDialog = () => {
      if (unsavedChanges) {
        // If there are unsaved changes, set a state to open the warning dialog
        setShowunsavedChangesWarning(true);
      } else {
        handleClose();
      }
    };

    const handleUnsavedChangesWarning = () => {
      handleSubmit();
    };

    const handleCloseUnsavedChangesWarning = () => {
      // setTabValue(0); // Reset tab to default when closing without saving
      setUnsavedChanges(false); // Reset unsaved changes flag
      handleClose();
      // If user cancels and chooses not to continue, close the warning dialog
      setShowunsavedChangesWarning(false);
    };

    const handleAddReminder = () => {
      if (newReminder.date) {
        // console.log("Adding new reminder:", newReminder);
        // Add the new reminder to the reminders array
        setReminders(prev => [...prev, {
          date: newReminder.date,
          alternativeMessage: newReminder.alternativeMessage,
          isResolved: newReminder.isResolved
        }]);

        // Auto-progress status if currently NEW
        if (ticketData.ticketStatus === TICKET_STATUS.NEW) {
          const availableStatuses = ticketFilters?.find(filter => filter.ticketType.value === ticketData.ticketType)?.statuses || [];
          const inProgressStatus = availableStatuses.find(status => 
            status.value === TICKET_STATUS.IN_PROGRESS
          );
          
          if (inProgressStatus) {
            setTicketData(prev => ({
              ...prev,
              ticketStatus: inProgressStatus.value
            }));
          }
        }

        setUnsavedChanges(true);
        // Clear the form for the next reminder
        setNewReminder({
          date: null,
          alternativeMessage: '',
          isResolved: false
        });
      }
    };

    const deleteReminderMutation = useDeleteReminder();
    
    const handleDeleteReminder = async () => {
      if (deleteReminderDialog.index !== null && ticketData.id) {
        const reminder = reminders[deleteReminderDialog.index];
        if (reminder.id) {
          setLoading(true);
          try {
            const result = await deleteReminderMutation.mutateAsync({
              ticketId: ticketData.id,
              reminderId: reminder.id
            });
            if (result !== undefined) {
              setReminders(prev => prev.filter((_, i) => i !== deleteReminderDialog.index));
              setUnsavedChanges(true);
            }
          } finally {
            setLoading(false);
          }
        } else {
          // If reminder has no ID (not saved to backend yet), just remove from local state
          setReminders(prev => prev.filter((_, i) => i !== deleteReminderDialog.index));
          setUnsavedChanges(true);
        }
        setDeleteReminderDialog({ open: false, index: null });
      }
    };

    const handlePrioritySelect = (prioritySymbol: any, value: string) => {
      setSelectedPriority(prioritySymbol); // Update selected priority symbol
      setTicketData({ ...ticketData, priority: value }); // Update ticket data with selected priority
    };

    // Assignee Popover
    const [selectedAssigneeOption, setSelectedAssigneeOption] = useState(
      ticketData?.assignedToUser?.id ? ticketData.assignedToUser : null
    );
    const [openAssignee, setOpenAssignee] = useState(false);

    const handleAssigneeClose = () => {
      setOpenAssignee(false); // Close dropdown manually when needed
    };

    const handleAssigneeSelect = (event: any, value: any) => {
      handleAssigneeClose(); // Close dropdown after selection

      if (value === null) {
        setSelectedAssigneeOption(null);
        setTicketData((prev) => ({
          ...prev,
          assignedToUser: undefined,
          assignedToUserId: undefined,
        }));
        setUnsavedChanges(true);
        return;
      }
      if (value?.id === "self-assign") {
        handleAssignToMe("assignedToUser"); // Assign to self if chosen
      } else if (value) {
        setSelectedAssigneeOption(value);
        setTicketData({
          ...ticketData,
          assignedToUser: {
            id: value.id,
            nickName: value.nickName,
            firstName: value.firstName,
            lastName: value.lastName,
          },
        });
      }
    };

    const filterCurrentLocation = (
      locationId: string,
      locations: LocationDto[]
    ): LocationDto | null => {
      const locationObj: LocationDto | undefined = locations?.filter(
        (location: LocationDto) => location.id === locationId
      )?.[0];

      if (locationObj) {
        // return { label: locationObj.name, value: locationObj.id };
        return locationObj;
      }
      return null;
    };
    const getLocationOptionObj = (locationId: string) => {
      const locationObj = filterCurrentLocation(locationId, locationsOptions);
      // console.log("LOCATION_OPTIONS", locationId, locationObj);
      if (locationObj) {
        return { label: locationObj.name, value: locationObj.id };
      }
      return null;
    };

    // Creater Popover
    // const [anchorCreaterEl, setAnchorCreaterEl] = useState<HTMLDivElement | null>(null);
    // const [openCreater, setOpenCreater] = useState(false);

    // const handleCreaterClick = (event: React.MouseEvent<HTMLDivElement>) => {
    //   setAnchorCreaterEl(event.currentTarget);
    //   setOpenCreater(!openCreater);
    // };

    // const handleCreaterClose = () => {
    //   setAnchorCreaterEl(null);
    //   setOpenCreater(false);
    // };
    // console.log("LOCATION_OPTIONS", getLocationOptionObj(ticketData.locationId));

    return (
      <Dialog open={openTicket} fullWidth maxWidth="xl" sx={{ height: "770px" }}>
        <DialogTitle>
          <TicketIcon sx={{ verticalAlign: "middle", mr: 1 }} />
          {"Neues Ticket"}
        </DialogTitle>

        <DialogContent>
          {!isTicketLoading && (
            <Box sx={{ display: 'flex', width: '98%', paddingTop: 1, margin: '0 auto', justifyContent: 'space-between' }}>
              <Box sx={{ flex: '0 0 47%'  }}>
     
            <Grid container spacing={2} sx={{display: "flex", justifyContent: "space-between", marginTop: "0rem"}}>
                  <Grid item xs={5.75} sx={{ border: "0px solid red" }}>
                    <Autocomplete
                  sx={{ margin: "0px", width: "100%" }}
                  disablePortal
                  options={
                    ticketFilters?.map((filter) => ({
                      value: filter.ticketType.value,
                      label: filter.ticketType.label,
                    })) || []
                  }
                  value={
                    ticketFilters?.find(
                      (filter) => filter.ticketType.value === ticketData.ticketType
                    )?.ticketType || null
                  } // Provide the entire object, not just the value string
                  onChange={(e, value) => {
                    const newTicketType = value?.value || "";
                    const selectedFilter = ticketFilters?.find(
                      (filter) => filter.ticketType.value === newTicketType
                    );
                    
                    // Update ticket type, status, and priority to ensure consistency
                    setTicketData(prev => ({
                      ...prev,
                      ticketType: newTicketType,
                      ticketStatus: selectedFilter?.statuses?.[0]?.value || TICKET_UI_DEFAULTS.STATUS,
                      priority: selectedFilter?.priorities?.[0]?.value || TICKET_PRIORITY.LOW,
                    }));
                    setUnsavedChanges(true);
                  }}
                  getOptionLabel={(option) => option?.label || ""} // Display the label (guard with fallback)
                  isOptionEqualToValue={(option, value) => option?.value === value?.value} // Compare full objects
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Problemtyp"
                      name="ticketType"
                      sx={{ margin: "0px", width: "100%" }}
                    />
                  )}
                />
              </Grid>

              <Grid
                item
                xs={5.75}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <Autocomplete
                  sx={{ margin: "0px", width: "100%" }}
                  disablePortal
                  options={
                    locationsOptions?.map((location: any) => ({
                      value: location.id,
                      label: location.name,
                    })) || []
                  }
                  value={ticketData.locationId ? getLocationOptionObj(ticketData.locationId) : null}
                  onChange={(e, value) => {
                    handleChange({ target: { name: "locationId", value: value?.value || "" } });
                  }}
                  getOptionLabel={(option) => option?.label || ""}
                  isOptionEqualToValue={(option, value) => option?.value === value?.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Standort"
                      name="location"
                      sx={{ margin: "0px", width: "100%" }}
                    />
                  )}
                />
              </Grid>
            </Grid>

              <Grid container spacing={2} sx={{display: "flex",  marginTop: "0rem"}}>

              <Grid
                item
                xs={2}
                sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
              >
                <Typography sx={{ textAlign: "center" }}>Erstellt von</Typography>

                {ticketData.createdByUser ? (
                  <MobiliAvatar
                    user={ticketData.createdByUser}
                    sx={{ width: 32, height: 32, fontSize: "0.8rem", marginTop: "0.6rem" }}
                  />
                ) : (
                  <MobiliAvatar
                    user={user || undefined}
                    sx={{ width: 32, height: 32, fontSize: "0.8rem", marginTop: "0.6rem" }}
                  />
                )}
              </Grid>
              
               <Grid
                item
                xs={3}
                sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
              >
                <Typography sx={{ textAlign: "center" }}>Erledigt bis</Typography>

                <div style={{display: "flex"}}>
                <Avatar
                sx={{
                  width: 36,
                  height: 36,
                  bgcolor: "transparent",
                  color: "text.primary",
                  marginLeft: "1.75rem",
                  marginTop: "0.6rem",
                }}
              >
                <AccessTimeFilled fontSize="small" />
              </Avatar>
              <DatePicker
                label={false}
                value={ticketData.deadline ? new Date(ticketData.deadline) : null} // Convert ISO string to Date for picker
                  onChange={(newDate: Date | null) => {
                    setUnsavedChanges(true);
                    setTicketData((prev) => ({
                      ...prev,
                      // deadline: newDate ? newDate.toISOString() : undefined, // Save as ISO string
                      deadline: newDate && isValid(newDate) ? newDate.toISOString() : undefined,
                    }));
                  }}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { width: 150 },
                  },
                }}
              />
                   </div> 
              </Grid>

              <Grid
                item
                xs={5.75}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "column",
                  marginLeft: "auto",
                }}
              >
                <Autocomplete
                  disablePortal
                  options={[{ label: "Assign to me", id: "self-assign" }, ...userOptions]}
                  value={selectedAssigneeOption}
                  onChange={handleAssigneeSelect}
                  getOptionLabel={(option: any) =>
                    option.id === "self-assign"
                      ? option.label
                      : `${option.firstName} ${option.lastName}`
                  }
                  renderOption={(props, option: any) => (
                    <li
                      {...props}
                      style={{ width: "100%", display: "flex", alignItems: "center" }}
                      key={option.id}
                    >
                      {option.id === "self-assign" ? (
                        <Typography variant="body1" fontSize="14px" padding="2px">
                          Assign to me
                        </Typography>
                      ) : (
                        <>
                          <Avatar
                            sx={{ width: 32, height: 32, fontSize: "0.8rem", marginRight: 1 }}
                          >
                            {option.nickName}
                          </Avatar>
                          <Typography variant="body1" fontSize="12px" padding="2px">
                            {option.firstName} {option.lastName}
                          </Typography>
                        </>
                      )}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Zugewiesen"
                      variant="outlined"
                      sx={{ width: "100%", marginTop: 1 }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <Tooltip
                            title={selectedAssigneeOption || (ticketData?.assignedToUser as any)}
                          >
                            <>
                              <MobiliAvatar
                                user={selectedAssigneeOption || ticketData?.assignedToUser}
                                sx={{
                                  width: 32,
                                  height: 32,
                                  fontSize: "0.8rem",
                                  cursor: "pointer",
                                  display: "flex",
                                }}
                              />
                              {params.InputProps.endAdornment}
                            </>
                          </Tooltip>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              </Grid>

              <Grid container spacing={2} sx={{display: "flex", justifyContent: "space-between", marginTop: "0rem"}}>

              <Grid
                item
                xs={5.75}
                sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
              >
                <Involvements ticketData={ticketData} editable onLinkagesChange={handleLinkagesChange} onNavigate={handleClose} />
              </Grid>

              <Grid
                item
                xs={2.5}
                md={2.5}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  border: "0px solid red",
                }}
              >
                {ticketData.ticketType && (
                  <FlatCard title="Status" sx={{ flexGrow: 1 }}>
                    <RadioGroup
                      sx={{ display: "flex", padding: "0px", margin: "0px" }}
                      aria-label="status"
                      name="status"
                      value={ticketData?.ticketStatus || TICKET_UI_DEFAULTS.STATUS}
                      onChange={(e) =>
                        handleChange({ target: { name: "ticketStatus", value: e.target.value } })
                      }
                    >
                      {ticketFilters
                        .find((filter) => filter.ticketType.value == ticketData?.ticketType)
                        ?.statuses.map((status, index) => (
                          <FormControlLabel
                            key={status.value + index}
                            value={status.value}
                            control={<Radio sx={{ padding: "2px" }} />}
                            label={
                              <Typography sx={{ fontSize: "0.75rem" }}>{status.label}</Typography>
                            }
                          />
                        ))}
                    </RadioGroup>
                  </FlatCard>
                )}
              </Grid>

              <Grid item xs={2.5} md={2.5} sx={{ border: "0px solid red", flexDirection: "column" }}>
                {ticketData.ticketType && ticketFilters
                  .find((filter) => filter.ticketType.value === ticketData?.ticketType)
                  ?.hasPriorities && (
                  <FlatCard title="Priorität" sx={{ flexGrow: 1 }}>
                    <RadioGroup
                      sx={{ display: "flex", padding: "0px", margin: "0px" }}
                      aria-label="priority"
                      name="priority"
                      value={ticketData?.priority || TICKET_PRIORITY.LOW}
                      onChange={(e) =>
                        handleChange({ target: { name: "priority", value: e.target.value } })
                      }
                    >
                      {ticketFilters
                        .find((filter) => filter.ticketType.value == ticketData?.ticketType)
                        ?.priorities.map((priority, index) => (
                          <FormControlLabel
                            key={priority.value + index}
                            value={priority.value}
                            control={<Radio sx={{ padding: "2px" }} />}
                            label={
                              <Typography sx={{ fontSize: "0.75rem" }}>{priority.label}</Typography>
                            }
                          />
                        ))}
                    </RadioGroup>
                  </FlatCard>
                )}
              </Grid>
              </Grid>

              <Grid item xs={12} sx={{ border: "0px solid red", height: '80px', marginTop: "0.3rem" }}>
                <TextField
                  fullWidth
                  label="Beschreibung"
                  name="description"
                  value={ticketData.description}
                  onChange={handleChange}
                  variant="outlined"
                  multiline
                  rows={2}
                  sx={{ height: '100%' }}
                />
              </Grid>
            </Box>

    

              {/* Right section - Tabs */}
              <Box sx={{ flex: '0 0 47%', marginLeft: 2 }}>
                          <Typography sx={{  marginTop: "1rem", paddingLeft: "0.5rem", fontSize: 20 }}>Wiedervorlage </Typography>

                <Box
                  sx={{
                    backgroundColor: mobiliTheme.lowLevelContainerBackground,
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    padding: "1rem",
                    marginTop: "0.5rem",
                    width: "100%",
                  }}
                >
                  <Typography variant="body2" sx={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
                    Wiedervorlage hinzufügen
                  </Typography>


                   <Grid container spacing={2} sx={{ marginBottom: "0.75rem" }}>
                    <Grid item xs={4.5}>
                <div style={{display: "flex"}}>
                <Avatar
                sx={{
                  width: 36,
                  height: 36,
                  bgcolor: "transparent",
                  color: "text.primary",
                  marginTop: "0.6rem",
                }}
              >
                <AccessTimeFilled fontSize="small" />
              </Avatar>
              <DatePicker
                label={false}
                value={newReminder.date}
                minDate={new Date()} // Set minimum date to today
                onChange={(newDate: Date | null) => {
                  setNewReminder(prev => ({
                    ...prev,
                    date: newDate
                  }));
                }}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { width: 200 },
                  },
                }}
              />
                   </div> 
                    </Grid>
                        <Grid item xs={7.5} sx={{ marginLeft: 'auto' }}>
                      <Box sx={{ width: '100%', position: 'relative' }}>
                        <TextField
                          fullWidth
                          label="Alternative Botschaften"
                          name="alternativeMessage"
                          value={newReminder.alternativeMessage}
                          onChange={(e) => setNewReminder(prev => ({
                            ...prev,
                            alternativeMessage: e.target.value
                          }))}
                          variant="outlined"
                          multiline
                          rows={2}
                        />
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                          <Button
                            variant="contained"
                            onClick={handleAddReminder}
                            disabled={!newReminder.date}
                          >
                            Wiedervorlage hinzufügen
                          </Button>
                        </Box>
                      </Box>
                    </Grid>

                </Grid>
              </Box>
           

                  {/* Display existing reminders */}
              {reminders.length > 0 && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: "bold" }}>
                    Bestehende Wiedervorlage 
                  </Typography>

                  <Box sx={{ 
                    display: "flex", 
                    flexDirection: "column", 
                    backgroundColor: "white",
                    border: "2px solid #e0e0e0",
                    borderRadius: "6px",
                    overflow: "hidden",
                    pt: 1,
                    pb: 2
                  }}>
                    {reminders.map((reminder, index) => {
                      const displayDate = reminder.date
                        ? format(new Date(reminder.date), 'dd.MM.yyyy')
                        : "-";

                      const statusIcon = (() => {
                            return <CheckBoxOutlineBlank sx={{ fontSize: 18 }} />;
                      })();

                      return (
                          <Box
                          key={reminder.id ?? index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            py: 0.25,
                            position: "relative",
                            "&::after": {
                              content: '""',
                              position: "absolute",
                              bottom: 0,
                              left: "2rem",
                              right: "2rem",
                              height: "2px",
                              backgroundColor: "rgba(0, 0, 0, 0.15)"
                            }
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", minWidth: "180px", paddingLeft: '2rem' }}>
                      
                            <Typography variant="body2">
                              {displayDate}
                            </Typography>
                          </Box>

                          <Typography 
                            variant="body2" 
                            sx={{ 
                              flex: 1,
                              color: "text.primary",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis"
                            }}
                          >
                            {reminder.alternativeMessage || "-"}
                          </Typography>
                          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                        

                                {ticketData.reminders && (
                                <MobiliAvatar
                                  user={ticketData.reminders && ticketData.reminders[index] && ticketData.reminders[index].createdByUser ? ticketData.reminders[index].createdByUser : undefined}
                                  sx={{ width: 24, height: 24, fontSize: '0.7rem' }}
                                />
                              )}
                              
                            <IconButton
                              size="small"
                              onClick={() => {
                                setEditReminderDialog({
                                  open: true,
                                  reminder: {
                                    id: reminder.id,
                                    date: reminder.date,
                                    alternativeMessage: reminder.alternativeMessage,
                                    isResolved: reminder.isResolved
                                  },
                                  index: index
                                });
                              }}
                            >
                              <Edit fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setDeleteReminderDialog({ open: true, index });
                              }}
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                                <Box sx={{ 
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: 1,
                                  px: 0,
                                  py: 0.5,
                                  minWidth: 44,
                                  marginRight: '1.5rem',
                                }}>
                                  {statusIcon}
                                </Box>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              )}
              </Box>
                </Box>

                

          )}
          <Modal
            open={userOptions.length === 0 || isTicketLoading || loading}
            aria-labelledby="loading-modal-title"
            aria-describedby="loading-modal-description"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div>
              <CircularProgress size={60} />
            </div>
          </Modal>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTicketFormDialog} variant="text">
            Abbrechen
          </Button>
          <Button disabled={loading} onClick={(e: any) => handleSubmit(e)}>
            Speichern
          </Button>
        </DialogActions>

        {/* Delete Reminder Confirmation Dialog */}
        <Dialog
          open={deleteReminderDialog.open}
          onClose={() => setDeleteReminderDialog({ open: false, index: null })}
        >
          <DialogTitle>Wiedervorlage löschen</DialogTitle>
          <DialogContent>
            <Typography>
              Möchten Sie diese Wiedervorlage wirklich löschen?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setDeleteReminderDialog({ open: false, index: null })}
              variant="text"
            >
              Abbrechen
            </Button>
            <Button
              onClick={handleDeleteReminder}
              variant="contained"
              color="error"
            >
              Löschen
            </Button>
          </DialogActions>
        </Dialog>

        <EditReminderDialog
          open={editReminderDialog.open}
          onClose={() => setEditReminderDialog(prev => ({ ...prev, open: false }))}
          reminder={editReminderDialog.reminder || {
            date: null,
            alternativeMessage: "",
            isResolved: false
          }}
          showStatusSelector={false}
          onSave={(updatedReminder) => {
            if (editReminderDialog.index !== null) {
              setReminders(prev => prev.map((r, i) => 
                i === editReminderDialog.index ? updatedReminder : r
              ));
              setUnsavedChanges(true);
            }
          }}
        />

        <WarningDialog
          open={unsavedChangesWarning}
          onClose={handleCloseUnsavedChangesWarning}
          onContinue={handleUnsavedChangesWarning}
          title="Änderungen speichern?"
          content="Du hast einige Änderungen gemacht. Möchtest du diese speichern, bevor du schließt?"
          isConfirmSave
        />
      </Dialog>
    );
  }
);

export default CreateTicketForm;
